export enum AvatarSettingsView {
  Add,
  Edit,
  SelectAvatar,
}
